import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=bec023da&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=bec023da&prod&lang=scss&scoped=true"
import style1 from "./edit.vue?vue&type=style&index=1&id=bec023da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec023da",
  null
  
)

export default component.exports